(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["solena-florea-carousel"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('solena-florea-marquee')){
  customElements.define('solena-florea-marquee',class extends HTMLElement{
    connectedCallback(){
      if(this._cleanup)this._cleanup();
      const viewport=this.querySelector('.sf-carousel__viewport');
      const track=this.querySelector('.sf-carousel__track');
      const group=this.querySelector('.sf-carousel__group');
      if(!viewport||!track||!group)return;
      const controller=new AbortController(),signal=controller.signal;
      const reduced=matchMedia('(prefers-reduced-motion: reduce)');
      const saveData=Boolean(navigator.connection&&navigator.connection.saveData);
      const videos=Array.from(this.querySelectorAll('[data-sf-video]'));
      const visibleVideos=new Set();
      const duration=(parseFloat(getComputedStyle(this).getPropertyValue('--sf-duration'))||50)*1000;
      const animation=track.animate([{transform:'translateX(0)'},{transform:'translateX(-33.3333333333%)'}],{duration,iterations:Infinity,easing:'linear'});
      animation.pause();
      let timer,pointer=null,startX=0,startY=0,startTime=0,inView=false;
      const mayPlay=()=>inView&&!document.hidden&&!reduced.matches&&!saveData;
      const syncMedia=()=>videos.forEach(video=>{
        if(!mayPlay()||!visibleVideos.has(video)){video.pause();return;}
        const play=video.play();
        if(play&&play.catch)play.catch(()=>{video.controls=true;video.classList.add('is-ready');});
      });
      const motion=()=>{
        if(mayPlay()&&pointer===null)animation.play();else animation.pause();
        syncMedia();
      };
      const observer='IntersectionObserver' in window?new IntersectionObserver(entries=>{
        entries.forEach(entry=>{
          const video=entry.target;
          if(entry.isIntersecting){
            visibleVideos.add(video);
            if(!video.hasAttribute('src')){
              video.poster=video.dataset.poster;
              video.src=video.dataset.src;
              if(saveData||reduced.matches){video.controls=true;video.classList.add('is-ready');}
            }
          }else visibleVideos.delete(video);
        });
        syncMedia();
      },{threshold:0.05}):null;
      videos.forEach(video=>{
        video.addEventListener('loadeddata',()=>video.classList.add('is-ready'),{signal});
        video.addEventListener('error',()=>video.classList.remove('is-ready'),{signal});
        if(observer)observer.observe(video);
        else{video.poster=video.dataset.poster;video.src=video.dataset.src;video.controls=true;video.classList.add('is-ready');}
      });
      const visibilityObserver='IntersectionObserver' in window?new IntersectionObserver(entries=>{
        inView=entries[0].isIntersecting;motion();
      },{threshold:0.01}):null;
      if(visibilityObserver)visibilityObserver.observe(this);
      else{inView=true;motion();}
      const wrap=t=>((t%duration)+duration)%duration;
      const stop=()=>{clearTimeout(timer);animation.pause();};
      const resume=()=>{clearTimeout(timer);timer=setTimeout(motion,1400);};
      const step=direction=>{
        stop();
        const card=group.querySelector('.sf-carousel__card');
        const distance=(card?card.getBoundingClientRect().width:160)+(parseFloat(getComputedStyle(group).gap)||10);
        const width=group.getBoundingClientRect().width;
        if(width)animation.currentTime=wrap((animation.currentTime||0)+direction*distance/width*duration);
        resume();
      };
      viewport.addEventListener('pointerdown',event=>{
        if(!event.isPrimary||(event.pointerType==='mouse'&&event.button!==0)||event.target.closest('video[controls]'))return;
        stop();pointer=event.pointerId;startX=event.clientX;startY=event.clientY;startTime=animation.currentTime||0;
        viewport.setPointerCapture(pointer);viewport.classList.add('is-dragging');
      },{signal});
      viewport.addEventListener('pointermove',event=>{
        if(event.pointerId!==pointer)return;
        const dx=event.clientX-startX,dy=event.clientY-startY;
        if(event.pointerType!=='mouse'&&Math.abs(dy)>Math.abs(dx)&&Math.abs(dx)<8)return;
        const width=group.getBoundingClientRect().width;
        if(width)animation.currentTime=wrap(startTime-dx/width*duration);
      },{signal});
      const release=event=>{if(event.pointerId!==pointer)return;pointer=null;viewport.classList.remove('is-dragging');resume();};
      viewport.addEventListener('pointerup',release,{signal});
      viewport.addEventListener('pointercancel',release,{signal});
      viewport.addEventListener('lostpointercapture',release,{signal});
      viewport.addEventListener('dragstart',event=>event.preventDefault(),{signal});
      viewport.addEventListener('keydown',event=>{
        if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();step(event.key==='ArrowRight'?1:-1);}
      },{signal});
      this.querySelectorAll('[data-sf-step]').forEach(button=>button.addEventListener('click',()=>step(Number(button.dataset.sfStep)),{signal}));
      reduced.addEventListener('change',motion,{signal});
      document.addEventListener('visibilitychange',motion,{signal});
      this._cleanup=()=>{
        controller.abort();clearTimeout(timer);animation.cancel();
        if(observer)observer.disconnect();if(visibilityObserver)visibilityObserver.disconnect();
        videos.forEach(video=>video.pause());
      };
    }
    disconnectedCallback(){if(this._cleanup)this._cleanup();}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["solena-sticky-atc"]) return;
  try {
    
  (function init() {
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); return; }
    var bar = document.querySelector('[data-s-sticky]');
    var atc = document.querySelector('solena-product [data-atc]');
    if (!bar || !atc || !('IntersectionObserver' in window)) return;
    bar.hidden = false;
    var btn = bar.querySelector('[data-s-sticky-btn]');
    var label = atc.querySelector('[data-atc-label]');
    var sync = function () { if (label) btn.textContent = label.textContent.trim(); btn.disabled = atc.getAttribute('aria-disabled') === 'true'; };
    new MutationObserver(sync).observe(atc, { attributes: true, childList: true, subtree: true, characterData: true });
    sync();
    var show = function (on) {
      bar.classList.toggle('is-visible', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      btn.tabIndex = on ? 0 : -1;
    };
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      show(!e.isIntersecting && e.boundingClientRect.top < 0);
    }).observe(atc);
    /* Au chargement : afficher la photo du coloris présélectionné */
    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined('solena-product').then(function () {
        var sp = document.querySelector('solena-product');
        if (!sp || !sp.product || typeof sp.selection !== 'function' || typeof sp.goToMedia !== 'function') return;
        var sel = sp.selection();
        var v = sp.product.variants.filter(function (x) {
          return x.featured_media && sel.every(function (val, i) { return val === null || x.options[i] === val; });
        })[0];
        if (v) sp.goToMedia(v.featured_media.id);
      });
    }
    btn.addEventListener('click', function () {
      var form = atc.closest('form');
      var needsChoice = atc.dataset.state === 'choose';
      if (needsChoice) {
        var opts = document.querySelector('solena-product .sp-options') || form;
        opts.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      if (form && form.requestSubmit) form.requestSubmit(atc); else atc.click();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
